import { MapPanel } from 'elements/layout/minute/RightPanelLayout/MapPanel';
import { MarkerPanel } from 'elements/layout/minute/RightPanelLayout/MarkerPanel';
import { ToolPanel } from 'elements/layout/minute/RightPanelLayout/ToolPanel';
import { motion } from 'framer-motion';
import { EBorders } from 'libs/styles/styling';
import { EWorldAction } from 'libs/utils/world/worldTypes';
import { useContext } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const RightPanelLayout = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    function getContent() {
        if (
            [
                EWorldAction.DRAW,
                EWorldAction.ICON_V2,
                EWorldAction.IMAGE_V2,
                EWorldAction.TEXT,
                EWorldAction.DRAW,
                EWorldAction.LINE_V2,
                EWorldAction.DIRECTION,
                EWorldAction.POLYGON_V2,
                EWorldAction.LINE_V2_WALL,
                EWorldAction.POLYGON_V2_WALL,
                EWorldAction.UPLOAD,
                EWorldAction.INDOOR_STAND
            ].includes(ctxEdit.worldAction)
        ) {
            return <ToolPanel />;
        }

        if ([EWorldAction.SELECT, EWorldAction.POINT_SELECT].includes(ctxEdit.worldAction)) {
            const markersSelected = ctxEdit.selectedMarkers?.length ?? 0;

            if (markersSelected === 0) {
                return <MapPanel />;
            }
            if (markersSelected === 1) {
                return <MarkerPanel />;
            }
        }
        return null;
    }

    const isInteractivitySelected =
        ctxEdit.markerSidebar === 'interactivity' && ctxEdit.selectedMarkers?.length === 1;

    function getAnimation() {
        if (isInteractivitySelected) {
            return {
                initial: { width: '350px', opacity: 0 },
                animate: { width: '450px', opacity: 1 },
                transition: { duration: 0.2 }
            };
        }
        return {};
    }

    return (
        <S_RightPanelLayout className={props.className}>
            <S_Content {...getAnimation()} $interactivitySelected={isInteractivitySelected}>
                {ctxEdit?.map?.worldMapId && getContent()}
            </S_Content>
        </S_RightPanelLayout>
    );
};

const S_RightPanelLayout = styled.div`
    width: 350px;
    height: 100%;
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    z-index: 2;
    position: relative;
`;

const S_Content = styled(motion.div)<{ $interactivitySelected: boolean }>`
    width: 350px;
    min-width: 350px;
    flex: 1;
    position: absolute;
    top: 0;
    right: 0;
    background: #efefef;
    box-shadow: -5px 5px 10px 0px rgba(0, 0, 0, 0.1);
    height: 100%;
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    border-left: 1px solid ${EBorders.DARK};
`;
